import React from "react";
import TopBar from "../../components/TopBar";
import SideBar from "../../components/SideBar";
import "../../styles/HelpPage.css";

const HelpPage = () => {
  return (
    <div>
      <TopBar pageTitle={"Помощь"} />
      <div className="main-container">
        <SideBar />

        <main className="home-main flex-grow-1">
          <div className="fl-page fl-help">
            {/* HERO */}
            <section className="fl-help__hero">
              <div className="fl-help__heroTitle">Помощь</div>
              <div className="fl-help__heroSub">
                Информация по моделям, выплатам и условиям работы с Fast Love.
              </div>
            </section>

            {/* БЛОК 1 */}
            <section className="fl-cardbox">
              <h2 className="fl-h2">Fast Love — кто мы такие и почему стоит работать с нами</h2>
              <p className="fl-help__p">
                Мы гордимся тем, что демонстрируем высокие показатели среди конкурентов. Наша платформа постоянно
                оптимизируется для максимальной конверсии и удержания пользователей, что напрямую влияет на ваш доход.
                Мы знаем, как превратить вашего пользователя в активного клиента, а значит, и ваш трафик — в стабильный
                и растущий заработок.
              </p>
              <p className="fl-help__p">
                Мы предлагаем исключительно приятные условия сотрудничества: своевременные выплаты, подробная статистика
                в личном кабинете, которая позволит вам отслеживать эффективность ваших кампаний в режиме реального
                времени, и, конечно же, оперативная поддержка от нашей команды, готовой помочь с любыми вопросами и
                предоставить рекомендации по оптимизации.
              </p>
              <p className="fl-help__p">
                Наша цель — не просто собрать как можно больше партнеров, а построить долгосрочные и взаимовыгодные
                отношения, где каждый сможет максимально монетизировать свой трафик. Мы верим, что ваш успех — это и наш
                успех.
              </p>
            </section>

            {/* БЛОК 2 */}
            <section className="fl-cardbox">
              <h2 className="fl-h2">Какую модель оплат выбрать?</h2>
              <p className="fl-help__p">
                Мы предлагаем гибкие и прозрачные модели сотрудничества, чтобы каждый мог найти оптимальный вариант для
                своего трафика. Каждая модель имеет свои преимущества и подходит для разных стратегий:
              </p>

              <div className="fl-help-grid">
                <article className="fl-help-tile">
                  <h3 className="fl-help-h3">Revshare (Доля от дохода)</h3>
                  <p className="fl-help__p"><b>Суть:</b> процент от всех покупок/пополнений ваших пользователей на протяжении всего их жизненного цикла.</p>
                  <p className="fl-help__p"><b>Для кого:</b> долгосрок, качественный трафик, повторные покупки.</p>
                  <p className="fl-help__p"><b>Преимущества:</b> высокий потенциал в перспективе, стабильность.</p>
                </article>

                <article className="fl-help-tile">
                  <h3 className="fl-help-h3">CPA-регистрация (Оплата за регистрацию)</h3>
                  <p className="fl-help__p"><b>Суть:</b> фикс за подтвержденную регистрацию.</p>
                  <p className="fl-help__p"><b>Для кого:</b> большой объем трафика, быстрый и предсказуемый доход.</p>
                  <p className="fl-help__p"><b>Преимущества:</b> низкий порог конверсии, быстрые выплаты.</p>
                </article>

                <article className="fl-help-tile">
                  <h3 className="fl-help-h3">CPA-покупка (Оплата за покупку)</h3>
                  <p className="fl-help__p"><b>Суть:</b> фикс за первую покупку (активацию подписки).</p>
                  <p className="fl-help__p"><b>Для кого:</b> платежеспособный трафик, «прогрев» аудитории.</p>
                  <p className="fl-help__p"><b>Преимущества:</b> высокая выплата за одну конверсию.</p>
                </article>

                <article className="fl-help-tile">
                  <h3 className="fl-help-h3">Revshare+ (Повышенный доход)</h3>
                  <p className="fl-help__p"><b>Суть:</b> выше процент, но по каждой подписке максимум два успешных платежа.</p>
                  <p className="fl-help__p"><b>Для кого:</b> максимизация прибыли при постоянном потоке трафика.</p>
                  <p className="fl-help__p"><b>Преимущества:</b> очень высокий процент, сильная монетизация.</p>
                </article>
              </div>
            </section>

            {/* БЛОК 3 */}
            <section className="fl-cardbox">
              <h2 className="fl-h2">Подробнее о RevShare и RevShare+</h2>
              <p className="fl-help__p">
                В 90% случаев пользователи для полноценного использования функционала совершают первую символическую
                покупку за 1 рубль. Затем через 24 часа система автоматически списывает одну из сумм подписки: 2999,
                1499, 799, 299 или 99 рублей. При обычной RevShare вы получаете доход на протяжении всего жизненного
                цикла подписки. При RevShare+ доход прекращается после второго автосписания, но процент выше.
              </p>
              <p className="fl-help__p">Мы соблюдаем интервалы при списывании каждой из сумм — всё происходит автоматически.</p>
              <p className="fl-help__p">
                Всем новым пользователям предлагается 50% RevShare и 85% RevShare+. По первой модели процент можно
                повысить, участвуя в конкурсах. Для крупных трафферов — индивидуальные условия.
              </p>
            </section>

            {/* БЛОК 4 */}
            <section className="fl-cardbox">
              <h2 className="fl-h2">С какими ГЕО мы работаем</h2>
              <p className="fl-help__p">
                В данный момент мы работаем только с Россией. В дальнейшем возможно расширение на страны СНГ и другие
                регионы.
              </p>
            </section>

            {/* БЛОК 5 */}
            <section className="fl-cardbox">
              <h2 className="fl-h2">Выплаты</h2>
              <p className="fl-help__p">
                Заказать выплату вы можете в любое время, при этом необходимо набрать минимальное количество — 2000 рублей.
              </p>
              <p className="fl-help__p">
                Выплаты производятся после подачи заявки, время обработки — от 1 до 7 дней. При задержках мы оповестим в
                нашем чате.
              </p>

              <div className="fl-table-wrap">
                <table className="fl-table">
                  <thead>
                    <tr>
                      <th>Способ</th>
                      <th>Валюта</th>
                      <th>Комиссия</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>USDT TRC20</td>
                      <td>USD</td>
                      <td>4$</td>
                    </tr>
                    <tr>
                      <td>USDT BEP20</td>
                      <td>USD</td>
                      <td>2$</td>
                    </tr>
                    <tr>
                      <td>ИП или ООО</td>
                      <td>RUB</td>
                      <td>Без комиссии</td>
                    </tr>
                    <tr>
                      <td>Самозанятый</td>
                      <td>RUB</td>
                      <td>1%</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="fl-note fl-help__note">
                При выплатах на ИП/ООО/Самозанятый мы заключаем с вами договор — для этого обратитесь к менеджеру.
              </div>
            </section>
          </div>
        </main>
      </div>
    </div>
  );
};

export default HelpPage;